module.exports = __webpack_public_path__ + "static/img/17.de02de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/17.png
// module id = BihU
// module chunks = 0